import {
  makeStyles, shorthands, tokens, createFocusOutlineStyle,
} from '@fluentui/react-components';

export const useThemeCellStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'block',
    position: 'relative',
    cursor: 'pointer',
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.overflow('hidden'),
    paddingTop: 0,
    paddingBottom: 0,

    '& .theme-cell-checkbox-indicator': {
      ...shorthands.borderWidth(0),
    },
    '&:hover .theme-cell-checkbox-indicator': {
      ...shorthands.borderWidth(tokens.strokeWidthThin),
    },
    '[aria-disabled="true"]': {
      cursor: 'auto',
    },
  },
  indicator: createFocusOutlineStyle({
    enableOutline: true,
  }),
  rootSelected: {
    outlineOffset: tokens.spacingVerticalXS,
    ...shorthands.outline(tokens.strokeWidthThick, 'solid', tokens.colorBrandBackground),

    '& .theme-cell-checkbox-indicator': {
      ...shorthands.borderWidth(tokens.strokeWidthThin),
    },

    ':focus': {
      outlineColor: tokens.colorNeutralForeground1,
    },
  },
  labelContainer: {
    position: 'absolute',
    top: tokens.spacingVerticalS,
    left: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding(tokens.spacingHorizontalXS),
  },
  label: {
    display: '-webkit-box',
    maxWidth: '180px',
    overflowWrap: 'break-word',
    color: 'transparent',
    backgroundImage: 'linear-gradient(135deg, #3D07D5 0%, #213AD5 45.05%, #0078D4 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 4,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    ...shorthands.overflow('hidden'),
  },
  checkbox: {
    position: 'absolute',
    zIndex: 1,
    top: tokens.spacingVerticalXS,
    right: tokens.spacingHorizontalXS,
  },
  spinnerContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
